<div class="container">

  <h1>Please review and approve how a loan agreement looks</h1>

  <app-loan-agreement-component-text></app-loan-agreement-component-text>

  <div style="text-align: center">
    <button mat-flat-button (click)="onAgreementAccepted()" class="primary font-small">Accept agreement and continue</button>
  </div>
</div>
